import { render } from "./InspirationGallery.vue?vue&type=template&id=dd2896e8&scoped=true"
import script from "./InspirationGallery.vue?vue&type=script&lang=js"
export * from "./InspirationGallery.vue?vue&type=script&lang=js"

import "./InspirationGallery.vue?vue&type=style&index=0&id=dd2896e8&lang=scss&scoped=true"
import "./InspirationGallery.vue?vue&type=style&index=1&id=dd2896e8&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd2896e8"]])

export default __exports__